import { useState } from "react";

export const useFetchAnswer = () => {
    const [isLoading, setIsLoading] = useState(false); // Estado para manejar el loading
    const [error, setError] = useState(null); // Estado para manejar errores

    const fetchAnswer = async (question) => {
        const url = `http://172.212.115.126:8080/pregunta?pregunta=${encodeURIComponent(question)}`;
        //const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ1c3VhcmlvQGNvcnJlby5jb20iLCJleHAiOjE3NDc2NzU3MjB9.dUN1MP5TNxfp4GgFjO2nnFRQUa87Kk653SQKYHEs1dk' //localStorage.getItem("token");
        try {
            setIsLoading(true);
            setError(null);

            const response = await fetch(url, {
                method: "GET",
                /* headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                }, */
            });

            const status = response.status;

            if (!response.ok) {
                const errorData = await response.json();
                return { status, data: errorData };
            }

            const data = await response.json();
            return { status, data };
        } catch (error) {
            setError(error.message);
            console.error("Error en useFetchAnswer:", error);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return { fetchAnswer, isLoading, error }; // Devuelve la función y los estados
};